import React from 'react'

import clsx from 'clsx'

import Paper from 'components/Paper'

import classes from './DrawerWrapper.module.scss'

/** @type {import("./types").default} */
const DrawerWrapper = ({
  children,
  onClose,
  anchor = 'left',
  modalProps = {},
  paperProps = {},
  className,
  shouldMount,
  stage,
  ...props
}) => (
  <div
    className={clsx(
      'Drawer',
      classes.root,
      classes[stage],
      { [classes.mount]: shouldMount },
      { [classes.unmount]: !shouldMount }
    )}
    role="presentation"
    {...props}
  >
    <div onClick={onClose} className={clsx(classes.backdrop, modalProps.BackdropProps?.className)} role="dialog" />
    <Paper
      square={paperProps?.square || true}
      elevation={paperProps?.elevation || 16}
      className={clsx(
        classes.paper,
        classes[`${stage}-paper-${anchor}`],
        classes[`paper-anchor-${anchor}`],
        paperProps?.className,
        className
      )}
    >
      {children}
    </Paper>
  </div>
)

export default DrawerWrapper
